import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_jax_4be1be27040983052c63e22ed424aac7",
  "use": "arrow_jax_4be1be27040983052c63e22ed424aac7-usage",
  "viewBox": "0 0 9 7",
  "content": "<symbol viewBox=\"0 0 9 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_jax_4be1be27040983052c63e22ed424aac7\">\n  <path d=\"M4.79743 6.08105L8.30131 1.73488C8.61773 1.34239 8.33836 0.758302 7.8342 0.758302H0.826443C0.322287 0.758302 0.0429123 1.34239 0.359337 1.73488L3.86322 6.08105C4.10338 6.37895 4.55727 6.37895 4.79743 6.08105Z\" fill=\"#697487\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol